export default function tagToPath(tag) {
    return tag.replace(/\s+/g, '-').toLowerCase();
}